import { useService } from 'solid-services'
import { useChannels, useNotifications } from '@state'
import {
	ErrorBoundary,
	type ParentProps,
	Show,
	createEffect,
	createSignal,
	onMount,
} from 'solid-js'
import { Motion, Presence } from 'solid-motionone'
import { css } from 'styled-system/css'
import { Grid } from 'styled-system/jsx'
import { darkmode } from './components/DarkMode'
import { useChannelsReads } from './state/channelReads/state'
import { useMessageMeta } from './state/messageMeta'

export const Splash = (props: ParentProps) => {
	// const { resolveUserStateResource } = useService(useAuth)()
	const { generalChannelsResource, setupChannelsResource } = useService(useChannels)()
	const { notificationsResource } = useService(useNotifications)()
	const { messageMetaResource } = useService(useMessageMeta)()
	const { channelReadsResource } = useService(useChannelsReads)()
	const [loading, setLoading] = createSignal(true)

	createEffect(async () => {
		// deugger
		if (
			// isOneSignalReady() &&
			messageMetaResource.state === 'ready' &&
			notificationsResource.state === 'ready' &&
			channelReadsResource.state === 'ready' &&
			generalChannelsResource.state === 'ready' &&
			setupChannelsResource.state === 'ready'
			// resolveUserStateResource.state === 'ready'
		) {
			setLoading(false)
		}
	})
	return (
		<div>
			<ErrorBoundary
				fallback={(error) => {
					console.error(error)
					return error
				}}
			>
				<Show
					when={!loading()}
					fallback={
						<Presence>
							<Motion
								initial={{ opacity: 0 }}
								animate={{ opacity: 1 }}
								exit={{ opacity: 0 }}
								transition={{ duration: 3 }}
							>
								<Grid
									h="100vh"
									w="100vw"
									justifyContent="center"
									alignItems="center"
								>
									<img
										class={css({
											height: '250px',
											width: '250px',
										})}
										src={`/${darkmode() ? 'logo' : 'logo_dark'}.png`}
										alt="sniper circle logo"
									/>
								</Grid>
							</Motion>
						</Presence>
					}
				>
					{props.children}
				</Show>
			</ErrorBoundary>
		</div>
	)
}
